var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { runtime } from '../../../runtime/Runtime';
export class FunnelLine {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get funnel() {
        return this.parent;
    }
    get tray() {
        return this.app.tray;
    }
    get app() {
        return this.funnel.app;
    }
    get funnelAnswers() {
        return this.funnel.funnelIncoming.remainingAnswersSorted;
    }
    get nextAnswer() {
        const [nextAnswer] = this.funnelAnswers;
        return nextAnswer;
    }
    get nextQuestionId() {
        const nextAnswer = this.nextAnswer;
        if (!nextAnswer) {
            return undefined;
        }
        console.log(`nextQuestionId: ${nextAnswer.question_id}`);
        return nextAnswer.question_id;
    }
    get preloadNextAnswer() {
        const nextAnswer = this.nextAnswer;
        if (!this.app.appBoot.isInteractive)
            return null;
        if (!runtime.browserRuntime)
            return null;
        if (this.app.appInfo.isUserCurrentlyEditing)
            return null;
        if (!nextAnswer)
            return null;
        if (!nextAnswer.answerPrepare.isPrepared)
            return null;
        const preloadQuestion = nextAnswer.availableQuestion;
        const questionImgs = preloadQuestion.importingTree.allImportingActors.filter(a => a instanceof runtime.class.AttachedImage);
        runtime.browserRuntime.browserPreload.preloadImages(questionImgs.map(image => image.imageThumb.thumbSrc));
        return true;
    }
}
__decorate([
    computed
], FunnelLine.prototype, "nextAnswer", null);
__decorate([
    computed
], FunnelLine.prototype, "preloadNextAnswer", null);
